import React from "react";
import CommonFunctions from "../commonFunctions.js";
import {
  Form,
  Button,
  FormGroup,
  Col,
  Row,
  InputGroup,
  FormControl,
  ControlLabel,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Breadcrumbs from "../Breadcrumbs";

class MainCategory extends CommonFunctions {
  constructor(props) {
    super(props);
    this.state = {
      validated: 0,
      breadcrum_params: [],
      name: "",
      parent_id: "0",
      mcategories: [],
      slug: "",
    };
    this.errors = [];
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    this.setState({ validated: this.state.validated + 1 });

    if (form.checkValidity() === true) {
      const url = "main_categories/" + this.props.match.params.slug;
      const params = {
        name: this.state.name,
        slug: this.state.slug,
        parent_id: this.state.parent_id,
      };
      this.apiCall(
        url,
        params,
        "../main-categories",
        "PUT",
        "Main Category updated"
      );
    }
  };

  componentDidMount() {
    var newBreadcrum = this.state.breadcrum_params.slice();
    newBreadcrum.push([1, "../main-categories", "Main Categories"]);
    newBreadcrum.push([0, 0, "Update Main Category"]);
    this.setState({ breadcrum_params: newBreadcrum });

    let url = "main_categories/" + this.props.match.params.slug;
    let params = {};
    this.apiCall(url, params, "", "GET", "").then((res) => {
      this.setState({
        name: res.data[0].name,
        slug: res.data[0].slug,
        parent_id: res.data[0].parent_id,
      });
    });

    this.apiCall("brands?create_for_dropdown_list=yes", "", "", "GET", "").then(
      (res) => {
        this.setState({ mcategories: res.data.mcategories1 });
      }
    );
  }

  render() {
    const { breadcrum_params } = this.state;
    return (
      <div>
        <Breadcrumbs params={breadcrum_params} />

        <Form
          noValidate
          validated={this.state.validated}
          onSubmit={this.handleSubmit}
        >
          <h3>Update Main Category</h3>
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="id01">
              <Form.Label>
                Main Category Name<span className="text-danger"> *</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="name"
                placeholder="Enter main category name"
                required
                value={this.state.name}
                onChange={this.validateInput}
                isInvalid={this.errors.name}
                autoFocus
                autoComplete="off"
              />
              <Form.Control.Feedback type="invalid">
                {this.errors.name
                  ? this.errors.name
                  : "Please provide main category name"}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="id02">
              <Form.Label>Parent Category</Form.Label>
              <select
                className="form-select"
                value={this.state.parent_id}
                name="parent_id"
                onChange={(e) => {
                  this.validateInput(e);
                }}
              >
                <option value="">Select Parent Category</option>
                {this.state.mcategories.length > 0 &&
                  this.state.mcategories.map((row, i) => (
                    <option key={i} value={row.id}>
                      {row.name}
                    </option>
                  ))}
              </select>
              <Form.Control.Feedback type="invalid">
                {this.errors.bname
                  ? this.errors.bname
                  : "Please select parent category"}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Button type="submit">Save</Button> &nbsp;
          <Button variant="secondary" onClick={this.goBack}>
            Cancel
          </Button>
        </Form>
      </div>
    );
  }
}

export default MainCategory;
